/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';

export const getFiles = (feature: BaseFeature): string[] => {
    return [
        'settings_schema.json',
    ];
};

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    let blocks: Array<CodeBlock> = [];
    const settings = feature.getSettingValue('SETTINGS');


    blocks.push({
        location: 'IMPORTS',
        blockType: BlockType.CODE,
        template: `
import hashlib
`,
    });

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.LOCATION,
        id: 'stg_set',
        template: `
def stg_set(name, value):
    with open('settings.json', 'r') as fp:
        settings = json.load(fp)
    settings[name] = value
    callback_stg_post_set(name, value)
    with open('settings.json', 'w') as fp:
        json.dump(settings, fp) 
    pass`,
    });

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.LOCATION,
        id: 'stg_init',
        template: `
def stg_restore_multiple():
    with open('settings_schema.json') as fp:
        settings_schema = json.load(fp)
    for setting, schema in settings_schema.items():
        stg_set(setting, schema['default'])
    pass`,
    });

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.LOCATION,
        id: 'stg_get',
        template: `
def stg_get(name):
    with open('settings.json', 'r') as fp:
        settings = json.load(fp)
    if name not in settings:
        return None
    return settings[name]`,
    });

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.LOCATION,
        id: 'callback_stg_post_set',
        template: `
def callback_stg_post_set(stg_name_or_num, stg_value):
    #****callback_stg_post_set****#
    pass
        `,
    });

    blocks.push({
        location: 'FUNCTION_DECLARATIONS',
        blockType: BlockType.LOCATION,
        id: 'stg_start',
        template: `
def stg_start():
    init = False
    with open('settings_schema.json') as fp:
        settings_schema = json.load(fp)
    if 'settings.json' not in os.listdir():
        settings = {}
        with open('settings.json', 'w') as fp:
            json.dump(settings, fp)
    else:
        with open('settings.json') as fp:
            settings = json.load(fp)
    if 'settings_hashes.json' not in os.listdir():
        settings_hashes = {}
        with open('settings_hashes.json', 'w') as fp:
            json.dump(settings_hashes, fp)
    else:
        with open('settings_hashes.json') as fp:
            settings_hashes = json.load(fp)
    for setting, schema in settings_schema.items():
        m=hashlib.sha256(str(schema['min']).encode() + str(schema['max']).encode() + schema['type'].encode())
        schema_hash = binascii.hexlify(m.digest()).decode()
        if setting not in settings_hashes:
            pass
        elif schema_hash != settings_hashes[setting]:
            init = True
        settings_hashes[setting] = schema_hash
    with open('settings.json', 'w') as fp:
        json.dump(settings, fp)
    with open('settings_hashes.json', 'w') as fp:
        json.dump(settings_hashes, fp)
    if init == True:
        print("The settings schema has changed. Restoring default values...")
        stg_restore_multiple()
`,
    });

    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
stg_start()`,
    });

    for (let i = 0; i < settings.length; i += 1) {
        const setting = settings[i];
        const settingBlocks = setting.getCodeBlocks();
        if (i === settings.length - 1) {
            settingBlocks[settingBlocks.length - 1]
                .template = settingBlocks[settingBlocks.length - 1]
                    .template.replace(/,(?=[^,]+$)/, '');
        }
        blocks = blocks.concat(settingBlocks);
        // if (setting.getSettingValue('SETTINGID').length > maxNameLength) {
        //     maxNameLength = setting.getSettingValue('SETTINGID').length;
        // }
        // const data_type = setting.getSettingValue('DATATYPE');

        // let required_str_len = 0;
        // let byte_size = 0;
        // switch (data_type) {
        //     case 'B':
        //         byte_size = 1;
        //         required_str_len = 3;
        //         break;
        //     case 'W':
        //         byte_size = 2;
        //         required_str_len = 5;
        //         break;
        //     case 'F':
        //         byte_size = 4;
        //         required_str_len = 4;
        //         break;
        //     case 'S':
        //         required_str_len = Number(setting.getSettingValue('MAX'));
        //         if (required_str_len === 0) {
        //             required_str_len = Number(setting.getDefault('MAX'));
        //         }
        //         byte_size = required_str_len + 1;
        //         break;
        //     case 'D':
        //         required_str_len = Number(setting.getSettingValue('MAX'));
        //         if (required_str_len === 0) {
        //             required_str_len = Number(setting.getDefault('MAX'));
        //         }
        //         byte_size = required_str_len + 1;
        //         required_str_len *= 4;
        //         if (required_str_len > 0) required_str_len -= 1;
        //         break;
        //     case 'T': // datetime timestamp
        //     case 'M': // Time
        //         byte_size = 4;
        //         required_str_len = 10;
        //         break;
        //     default:

        //         break;
        // }
        // if (maxValueLength < required_str_len) {
        //     maxValueLength = required_str_len;
        // }
        // byte_size = byte_size * Number(1) + 1;
        // if (STG_TIMESTAMP === '1') {
        //     byte_size += 7;
        // }
        // if (setting.getSettingValue('STORAGE') === 'R') {
        //     RAM_ARRAY_SIZE += byte_size;
        // }
    }

    return blocks;
};
